var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationFailedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.642,
    height: 25.87,
    viewBox: "0 0 20.642 25.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "failed_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57086",
    "data-name": "Group 57086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "gpp_maybe_FILL0_wght400_GRAD0_opsz48",
    d: "M18.321,29.82A12.666,12.666,0,0,1,10.9,24.565,15.364,15.364,0,0,1,8,15.527V7.83L18.321,3.95,28.642,7.83v7.7a15.364,15.364,0,0,1-2.9,9.038A12.666,12.666,0,0,1,18.321,29.82Z",
    transform: "translate(-8 -3.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155584",
    "data-name": "Path 155584",
    d: "M.745-4.365H-.922l-.236-7.01H.982Zm-.834,1.1a1.125,1.125,0,0,1,.816.3,1.017,1.017,0,0,1,.309.764,1.008,1.008,0,0,1-.309.757,1.125,1.125,0,0,1-.816.3,1.116,1.116,0,0,1-.809-.3A1.008,1.008,0,0,1-1.207-2.2,1.019,1.019,0,0,1-.9-2.965,1.109,1.109,0,0,1-.088-3.267Z",
    transform: "translate(10.649 19.21)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailedIcon);
export default __webpack_public_path__ + "static/media/verification-failed-icon.57408542530dc224a4c1744a382ea590.svg";
export { ForwardRef as ReactComponent };